// Sort whole objects so time/price/volume can never become mismatched.
export function boxLinePeaks(line) {
  return [...(line.peaks || [])]
    .filter((peak) => Number.isFinite(Date.parse(peak.timestamp_korean)))
    .sort((a, b) => Date.parse(a.timestamp_korean) - Date.parse(b.timestamp_korean));
}

export function boxLineTimes(line) {
  if (line.boxline_feature === 'turning_point_manual') {
    return [line.span_start, line.span_end].map(Date.parse).filter(Number.isFinite).sort((a, b) => a - b);
  }
  return boxLinePeaks(line).map((peak) => Date.parse(peak.timestamp_korean));
}
